//@ts-ignore
import React, { FC } from 'react';
import { FullscreenButtonStyled } from './styled';
import { ButtonProps } from './types';
import { Minimize, Maximize } from 'lucide-react';

const FullscreenButton: FC<ButtonProps & { children?: any }> = ({ onClick, isFullscreen }) => (
  <FullscreenButtonStyled onClick={onClick} isFullscreen={isFullscreen}>
    {isFullscreen ? <Minimize size={16} /> : <Maximize size={16} />}
  </FullscreenButtonStyled>
);

export default FullscreenButton;
